import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import api, { imgSrc } from "../lib/api";
import CtaBand from "../components/CtaBand";
import NotFound from "./NotFound";
import { Reveal, usePageMeta } from "../lib/motion";

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  usePageMeta(post ? post.title : "Article", post?.excerpt);

  useEffect(() => {
    setPost(null);
    setMissing(false);
    api
      .get(`/posts/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <NotFound />;
  if (!post) return <main className="min-h-screen bg-navy-deep" />;

  return (
    <main data-testid="blog-post-page">
      <section className="relative pt-40 pb-16 overflow-hidden">
        {post.cover_image && (
          <div className="absolute inset-0">
            <img src={imgSrc(post.cover_image)} alt="" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-deep/85 via-navy/85 to-navy-deep" />
          </div>
        )}
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6">
          <Reveal>
            <button
              onClick={() => navigate("/blog")}
              data-testid="blog-post-back-btn"
              className="mb-8 inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-slate-400 hover:text-gold font-display transition-colors"
            >
              <ArrowLeft className="h-4 w-4" /> BACK TO JOURNAL
            </button>
            <span className="inline-block glass-dark border border-gold/30 rounded-full px-4 py-1.5 text-[11px] font-bold tracking-[0.15em] text-gold font-display uppercase mb-5">
              {post.category}
            </span>
            <h1 className="font-display font-extrabold tracking-tight text-white leading-[1.1] text-3xl sm:text-4xl lg:text-5xl" data-testid="blog-post-title">
              {post.title}
            </h1>
            {post.created_at && (
              <p className="mt-5 flex items-center gap-2 text-xs text-slate-400">
                <CalendarDays className="h-4 w-4 text-gold" />
                {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            )}
          </Reveal>
        </div>
      </section>
      <section className="py-16 bg-navy-deep">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Reveal>
            <div className="space-y-6" data-testid="blog-post-content">
              {post.content.split(/\n+/).map((para, i) => (
                <p key={i} className="text-slate-300 leading-relaxed text-base sm:text-lg">
                  {para}
                </p>
              ))}
            </div>
            <p className="mt-12 pt-8 border-t border-white/10 text-xs text-slate-500 leading-relaxed">
              This article is for general information only and is not legal advice. Visa requirements are set by
              the relevant immigration authorities and may change. Application assistance does not guarantee
              visa approval.
            </p>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default BlogPostPage;
